import { AccountAuthApiService } from './service';
import ApiClientFactory from '../../api/client-factory';

const service = new AccountAuthApiService(ApiClientFactory());

export function AccountAuthApiServiceFactory(): typeof service {
  return service;
}
